import React from "react";
import { Flex } from "@catchoftheday/cg-components";
export const ContentZone = (props) => {
    return (<Flex data-testid={"modal-upsellModal"} flexDirection="column" alignItems="center" fontFamily="onePass" color="onePass.textPrimary" px={{
            sm: 2,
            md: 10,
        }} {...props}/>);
};
export const DivisionIconsZone = (props) => {
    return (<Flex width="100%" alignItems="center" justifyContent="space-between" fontSize="8xl" mb={6} {...props}/>);
};
export const BenefitItemZone = (props) => {
    return <Flex py={2} fontSize={{ xs: "sm", md: "base" }} {...props}/>;
};
export const PricingZone = (props) => {
    return <Flex mb={3} alignItems="flex-end" {...props}/>;
};
export const SecondaryCTAZone = (props) => {
    return (<Flex mt={4} alignItems="end" fontWeight="bold" fontSize="xs" {...props}/>);
};
